import type { SearchHeadlinesParams } from "@/widget-components/newsquawk-headlines/api/types";

/**
 * Is there actually anything to search for?
 *
 * An intent can come back empty in ways that all look the same downstream: the
 * model returned no terms, or every term failed to resolve and produced no
 * keyword. `transformSearchParams` would then send an empty `search_term` with
 * no tickers, tags or date range, and the wire would answer with everything —
 * which reads as "your question matched the entire archive" rather than as the
 * failure it is.
 *
 * The Headlines search form refuses the same case
 * (`!q.trim() && !startDate && !endDate`); this is that guard, extended to the
 * tickers and tags this path can also carry.
 */
export function isSearchable(config: SearchHeadlinesParams): boolean {
  const hasTickers = (config.portfolios ?? []).some(
    (p) => (p.tickers?.length ?? 0) > 0
  );
  return (
    !!config.query?.trim() ||
    hasTickers ||
    (config.tags?.length ?? 0) > 0 ||
    !!config.dateRange?.startDate
  );
}
